import { render, staticRenderFns } from "./lawsuit-follow-register.vue?vue&type=template&id=4814a5d6&scoped=true"
import script from "./lawsuit-follow-register.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow-register.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814a5d6",
  null
  
)

export default component.exports